<app-page-navigation></app-page-navigation>

<div class="page-body">
	
	<!--@if (currentStep && currentStep.currentStep < currentStep.maxSteps) {-->
		<app-wizard-progress></app-wizard-progress>
	<!--}-->

</div>
